var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9773C0 16.7789 0.289731 17.5478 0.805456 18.1147C1.32118 18.6815 2.02065 19 2.75 19H19.25C19.9793 19 20.6788 18.6815 21.1945 18.1147C21.7103 17.5478 22 16.7789 22 15.9773V7.66477H0V15.9773ZM3.24107 11.875C3.24107 11.4455 3.39628 11.0337 3.67257 10.73C3.94885 10.4263 4.32357 10.2557 4.71429 10.2557H7.07143C7.46215 10.2557 7.83687 10.4263 8.11315 10.73C8.38943 11.0337 8.54464 11.4455 8.54464 11.875V12.9545C8.54464 13.384 8.38943 13.7959 8.11315 14.0996C7.83687 14.4033 7.46215 14.5739 7.07143 14.5739H4.71429C4.32357 14.5739 3.94885 14.4033 3.67257 14.0996C3.39628 13.7959 3.24107 13.384 3.24107 12.9545V11.875ZM19.25 0H2.75C2.02065 0 1.32118 0.318465 0.805456 0.885337C0.289731 1.45221 0 2.22105 0 3.02273V4.42614H22V3.02273C22 2.22105 21.7103 1.45221 21.1945 0.885337C20.6788 0.318465 19.9793 0 19.25 0Z",
    fill: "#45526C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicingIcon);
export default __webpack_public_path__ + "static/media/servicing-icon.30a9e183797c426d960dd148be30fce1.svg";
export { ForwardRef as ReactComponent };